import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getEstimateItems(estimateId, params) {
        return Axios.get(
            `${baseURL}billing/estimate/estimate_items/${estimateId}`,
            {
                params: params
            }
        ).then(res => {
            if (
                res &&
                res.data &&
                res.data.response &&
                res.data.response.resources
            ) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    getEstimateItem(estimateItemId) {
        return Axios.get(
            `${baseURL}billing/estimate-item/${estimateItemId}`
        ).then(res => {
            if (
                res &&
                res.data &&
                res.data.response &&
                res.data.response.resources
            ) {
                return res.data.response.resources;
            }
            return null;
        });
    },
    postSave(params) {
        return Axios.post(`${baseURL}billing/estimate-item`, params).then(
            res => {
                if (res.data) {
                    return res.data.response;
                }
                return [];
            }
        );
    },
    postEdit(params) {
        return Axios.post(
            `${baseURL}billing/estimate-item/update-estimate-item`,
            params
        ).then(res => {
            if (res.data) {
                return res.data.response;
            }
            return [];
        });
    },
    declineItem(params) {
        return Axios.post(
            `${baseURL}billing/estimate-item/declineEstimateItem`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    deleteItem(estimateId, params) {
        return Axios.delete(`${baseURL}billing/estimate-item/${estimateId}`, {
            params
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    addBundle(params) {
        return Axios.post(`${baseURL}billing/estimate/add-bundle`, params).then(
            res => {
                if (res.data) {
                    return res.data.response;
                }
                return [];
            }
        );
    },
    updateEstimateItemOrder(params) {
        return Axios.post(
            `${baseURL}billing/estimate-item/reorder`,
            params
        ).then(res => {
            if (res.data) {
                return res.data.response;
            }
            return [];
        });
    },
    bulkDecline(params) {
        return Axios.post(
            `${baseURL}billing/decline-multiple-estimate-items`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    bulkDelete(params) {
        return Axios.post(
            `${baseURL}billing/delete-multiple-estimate-items`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    }
};
